import { render, staticRenderFns } from "./CustomCallout.vue?vue&type=template&id=61151acc&scoped=true"
import script from "./CustomCallout.vue?vue&type=script&lang=js"
export * from "./CustomCallout.vue?vue&type=script&lang=js"
import style0 from "./CustomCallout.vue?vue&type=style&index=0&id=61151acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61151acc",
  null
  
)

export default component.exports